import { callAPI } from "./core";

async function getFacilitySubscriptionOverrides(facilityId) {
  return await callAPI(
    `/facility/${facilityId}/subscription-overrides`,
    "GET",
    null,
    true
  );
}

async function setFacilitySubscriptionOverrides(facilityId, subscribed) {
  return await callAPI(
    `/facility/${facilityId}/subscription-overrides`,
    "PATCH",
    { subscribed: subscribed },
    true
  );
}

export { getFacilitySubscriptionOverrides, setFacilitySubscriptionOverrides };
